export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'



// WEBPACK FOOTER //
// ./src/modules/common.js